export default __webpack_public_path__ + "static/media/Charith Kongara - Newsletter Editor.92084970.jpg";